const Category = require('../entities/category');

const PagedList = require('../entities/paged-list');

const AccessContext = require('./contexts/access-context');

const symmetricDifference = require('../utils/symmetricDifference');

const fields = ['id', 'name', 'shortName', 'images'];

class BusinessCategoriesRepo {
  constructor(client
  /*: ApiClient*/
  , parentContext
  /*: AccessContext*/
  ) {
    this.client = client;
    this.context = parentContext;
  }

  list()
  /*: Promise<PagedList<Category>>*/
  {
    const {
      businessId
    } = this.context.serialize();
    const req = new this.client.Request(`/businesses/${businessId}/categories`, {}, fields);
    req.parse = Category.fromJson;
    return this.client.get(req);
  }

  listAll()
  /*: Promise<PagedList<Category>>*/
  {
    return this.list().then(this.client.pagination.loadRest);
  }

  link(categoryId
  /*: string*/
  )
  /*: Promise<any>*/
  {
    const {
      businessId
    } = this.context.serialize();
    const req = new this.client.Request(`/businesses/${businessId}/categories/${categoryId}/link`);
    return this.client.put(req);
  }

  unlink(categoryId
  /*: string*/
  )
  /*: Promise<any>*/
  {
    const {
      businessId
    } = this.context.serialize();
    const req = new this.client.Request(`/businesses/${businessId}/categories/${categoryId}/link`);
    return this.client.delete(req);
  }

  reconcile(categories
  /*: Array<string>*/
  , updatedCategories
  /*: Array<string>*/
  ) {
    const {
      left,
      right
    } = symmetricDifference(categories, updatedCategories);
    const adding = Promise.all(right.map(id => this.link(id)));
    const removing = Promise.all(left.map(id => this.unlink(id)));
    return Promise.all([adding, removing]);
  }

}

module.exports = BusinessCategoriesRepo;